import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhCN from './locales/zh-cn.json';
import chHK from './locales/ch-hk.json';
import en from './locales/en.json';

// 配置i18n
const resources = {
  'en': {
    translation: en
  },
  'zh': {
    translation: zhCN
  },
  'zh-CN': {
    translation: zhCN
  },
  'zh-cn': {
    translation: zhCN
  },
  'ch-hk': {
    translation: chHK
  },
  'zh-hk': {
    translation: chHK
  },
  'zh-HK': {
    translation: chHK
  }
};

// 从URL获取语言参数
const getLanguageFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');
  console.log('Language from URL:', lang);
  return lang;
};

// 初始化i18n
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getLanguageFromUrl() || 'zh-cn', // 默认使用中文简体
    fallbackLng: 'zh-cn', // 默认使用中文简体作为回退语言
    interpolation: {
      escapeValue: false
    },
    debug: true,
    supportedLngs: ['en', 'zh', 'zh-CN', 'zh-cn', 'ch-hk', 'zh-hk', 'zh-HK'],
    nonExplicitSupportedLngs: true // 允许i18next隐式支持更多语言代码
  });

export default i18n;